/**
 * `window.React`, for the design system — and for nothing of ours.
 *
 * This file used to hand React AND ReactDOM to the twenty-one source files,
 * because they had arrived as UMD script tags and every file read them bare.
 * They do not any more: each imports React for itself, and App.jsx imports
 * createRoot. ReactDOM is gone from here entirely.
 *
 * What is left is not ours to fix. `design-system/_ds_bundle.js` is generated
 * and synced in from Claude Design, loaded as a plain script tag in index.html,
 * and every component in it calls a bare `React.useState` / `React.createElement`
 * — 441 references — resolved against the global object. Rewriting it is not an
 * option: it is regenerated, so any edit is lost on the next sync.
 *
 * Ordering works out because the bundle only READS React when a component
 * renders, which is after this module has run. Nothing in it touches React at
 * definition time — no forwardRef, no memo, no createContext at top level,
 * checked rather than assumed.
 *
 * This disappears when the design system starts importing React itself. That is
 * a change to Claude Design, not to this repository.
 */
import React from "react";

window.React = React;
